const ACCRUALTYPE_LIST = [
  { key: '30+/360', value: '30+/360' },
  { key: '30/360', value: '30/360' },
  { key: '30/360 US', value: '30/360 US' },
  { key: '30E/360', value: '30E/360' },
  { key: '30E/365', value: '30E/365' },
  { key: 'ACT/360', value: 'ACT/360' },
  { key: 'ACT/365', value: 'ACT/365' },
  { key: 'ACT/ACT', value: 'ACT/ACT' },
  { key: 'ISDA 30E/360', value: 'ISDA 30E/360' },
  { key: 'ISDA SWAPS:30/360', value: 'ISDA SWAPS:30/360' },
  { key: 'ISMA-30/360', value: 'ISMA-30/360' },
  { key: 'ISMA-30/360 NONEOM', value: 'ISMA-30/360 NONEOM' },
  { key: 'NL/365', value: 'NL/365' },
  { key: 'ZERO', value: 'ZERO' },
]

const FINANCING_BASIS_LIST = [
  'NOTIONAL_COST',
  'NOTIONAL_COST_TD',
  'NOTIONAL_MKT_VAL',
  'NOTIONAL_MKT_VAL_TD',
]

const DIVIDEND_PAYMENT_TIMING_LIST = [
  'MATURITY',
  'NXT_EQUITY_RESET',
  'PAY_DATE',
  'UNWIND',
]
const REALISE_PL_TIMING_LIST = ['MATURITY', 'NXT_EQUITY_RESET', 'UNWIND']

const mapIdentifierField = (item, identType) => {
  if (identType === 'BB_TCM') {
    return item.ticker
  } else if (identType === '_CFD_BB_TCM') {
    return item.cfdTicker
  } else if (identType === 'ISIN') {
    return item.isin
  } else if (identType === 'WIND') {
    return item.wind
  } else if (identType === 'SEDOL') {
    return item.sedol
  } else if (identType === 'CUSIP') {
    return item.cusip
  } else if (identType === 'EXCH_SYMBOL') {
    return item.exchSymbol
  } else if (identType === 'BB_TCM_PX') {
    return item.tickerPx
  }
  return null
}

export {
  ACCRUALTYPE_LIST,
  FINANCING_BASIS_LIST,
  DIVIDEND_PAYMENT_TIMING_LIST,
  REALISE_PL_TIMING_LIST,
  mapIdentifierField,
}
